var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames", "../Icon/ArrowDown"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"), require("../Icon/ArrowDown"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames, global.ArrowDown);
    global.Dropdown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames, _ArrowDown) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _ArrowDown = _interopRequireDefault(_ArrowDown);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var Dropdown = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(Dropdown, _PureComponent);

    var _super = _createSuper(Dropdown);

    function Dropdown(props) {
      var _this;

      (0, _classCallCheck2.default)(this, Dropdown);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNavToggle", function () {
        _this.setState({
          expanded: !_this.state.expanded
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onItemSelect", function (item, event) {
        _this.setState({
          placeholder: item.label,
          expanded: false
        });

        _this.props.onItemSelect(item, event);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (event) {
        if (_this.dropdown && _this.state.expanded) {
          if (_this.dropdown && !_this.dropdown.contains(event.target)) {
            _this.setState({
              expanded: false
            });
          }
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (ref) {
        _this.dropdown = ref;
      });
      _this.state = {
        expanded: false,
        placeholder: props.placeholder
      };
      _this.ref = null;
      return _this;
    }

    (0, _createClass2.default)(Dropdown, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        global.document.addEventListener('mousedown', this.handleClickOutside);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        global.document.removeEventListener('mousedown', this.handleClickOutside);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            className = _this$props.className,
            legend = _this$props.legend,
            items = _this$props.items;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('next-dropdown', className, {
            'is-expanded': this.state.expanded
          }),
          ref: this.init
        }, legend && /*#__PURE__*/_react.default.createElement("span", {
          className: "next-dropdown__legend"
        }, legend), /*#__PURE__*/_react.default.createElement("button", {
          className: "next-dropdown__toggle",
          "aria-expanded": this.state.expanded ? 'true' : 'false',
          onClick: this.onNavToggle
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "next-dropdown__placeholder"
        }, this.state.placeholder), /*#__PURE__*/_react.default.createElement(_ArrowDown.default, {
          className: "next-dropdown__icon",
          size: "xsmall"
        })), /*#__PURE__*/_react.default.createElement("ul", {
          className: "next-dropdown__list"
        }, items.map(function (item) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: "item-".concat(item.id),
            className: "next-dropdown__item"
          }, item.url ? /*#__PURE__*/_react.default.createElement("a", {
            className: "next-dropdown__link",
            href: item.url
          }, item.label) : /*#__PURE__*/_react.default.createElement("button", {
            className: "next-dropdown__link",
            onClick: function onClick(event) {
              return _this2.onItemSelect(item, event);
            },
            tabIndex: "0"
          }, item.label));
        })));
      }
    }]);
    return Dropdown;
  }(_react.PureComponent);

  Dropdown.propTypes = {
    className: _propTypes.default.string,
    legend: _propTypes.default.string,
    items: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    onItemSelect: _propTypes.default.func,
    placeholder: _propTypes.default.string
  };
  Dropdown.defaultProps = {
    className: '',
    legend: '',
    items: [],
    onItemSelect: function onItemSelect() {
      return null;
    },
    placeholder: 'Select...'
  };
  var _default = Dropdown;
  _exports.default = _default;
});